import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfcd809c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "default-license-title" }
const _hoisted_3 = { class: "ml-[15px]" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "default-license-title" }
const _hoisted_6 = { class: "ml-[21px]" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import IncrediSelectMenu from '@/components/inputs/incrediSelectMenu.vue';
import { inject, onMounted, ref, watch } from 'vue';
import { QUERY_RESULT_PATH, SettingsPageWindowsQuery, License_RegistrationType } from '@/graphql/codegen/generated/graphql';
import { IKSettingsDirty } from '@/types/injectionKeys';
import { useDefaultAgentLicense, InitiatorsMenuOptions, setInitiatorType } from '@/views/settings/components/settingsDefaultAgentLicense/settings-default-agent-license.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'settings-default-agent-license-value',
  props: {
    modelValue: null,
    disable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  modelValue: NonNullable<SettingsPageWindowsQuery['ibManagerEntities']>;
  disable: boolean;
}


const settingsDirty = inject(IKSettingsDirty);

const { initiatorsTypesList, helpersTypesList } = useDefaultAgentLicense();

const selectedHelperType = ref(License_RegistrationType.None);
const selectedInitiatorType = ref(InitiatorsMenuOptions.None);

const setDefaultLicenseSelection = (modelValue: NonNullable<SettingsPageWindowsQuery['ibManagerEntities']>) => {
  selectedHelperType.value = modelValue?.settings?.windows?.license?.defaultHelperType || License_RegistrationType.None;
  selectedInitiatorType.value = setInitiatorType(
    modelValue?.settings?.windows?.license?.defaultInitiatorType || License_RegistrationType.None,
    modelValue?.settings?.windows?.license?.defaultCIInitiatorType || License_RegistrationType.None,
  );
};

onMounted(() => {
  setDefaultLicenseSelection(props.modelValue);
});

watch(
  () => props.modelValue,
  updatedValue => {
    setDefaultLicenseSelection(updatedValue);
  },
  { immediate: true, deep: true },
);

const handleHelperSelection = (value: License_RegistrationType) => {
  // no need to update if the value is the same
  if (value === props.modelValue?.settings?.windows?.license?.defaultHelperType) {
    return;
  }
  settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultHelperType, value);
  selectedHelperType.value = value;
};

const isInitiatorMenuChosenOptionDirty = (value: InitiatorsMenuOptions) => {
  if (
    value === InitiatorsMenuOptions.None &&
    props.modelValue?.settings?.windows?.license?.defaultInitiatorType === License_RegistrationType.None &&
    props.modelValue?.settings?.windows?.license?.defaultCIInitiatorType === License_RegistrationType.None
  ) {
    return false;
  }
  if (
    (value === InitiatorsMenuOptions.FloatingCI && props.modelValue?.settings?.windows?.license?.defaultCIInitiatorType === License_RegistrationType.Floating) ||
    (value === InitiatorsMenuOptions.FixedCI && props.modelValue?.settings?.windows?.license?.defaultCIInitiatorType === License_RegistrationType.Fixed)
  ) {
    return false;
  }
  if (
    (value === InitiatorsMenuOptions.FixedInitiator && props.modelValue?.settings?.windows?.license?.defaultInitiatorType === License_RegistrationType.Fixed) ||
    (value === InitiatorsMenuOptions.FloatingInitiator && props.modelValue?.settings?.windows?.license?.defaultInitiatorType === License_RegistrationType.Floating)
  ) {
    return false;
  }
  return true;
};

const handleInitiatorSelection = (value: InitiatorsMenuOptions) => {
  // no need to update if the value is the same
  if (!isInitiatorMenuChosenOptionDirty(value)) {
    return;
  }
  selectedInitiatorType.value = value;
  if (value === InitiatorsMenuOptions.FloatingCI || value === InitiatorsMenuOptions.FixedCI) {
    const valueToUpdate = value === InitiatorsMenuOptions.FloatingCI ? License_RegistrationType.Floating : License_RegistrationType.Fixed;
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultCIInitiatorType, valueToUpdate);
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultInitiatorType, License_RegistrationType.None);
  }
  if (value === InitiatorsMenuOptions.FloatingInitiator || value === InitiatorsMenuOptions.FixedInitiator) {
    const valueToUpdate = value === InitiatorsMenuOptions.FloatingInitiator ? License_RegistrationType.Floating : License_RegistrationType.Fixed;
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultInitiatorType, valueToUpdate);
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultCIInitiatorType, License_RegistrationType.None);
  }
  if (value === InitiatorsMenuOptions.None) {
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultInitiatorType, value);
    settingsDirty?.setInputsDirty(QUERY_RESULT_PATH.settings.windows.license.defaultCIInitiatorType, value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settings.agents.defaultAgentLicense.initiatorMenuTitle')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(IncrediSelectMenu, {
            value: selectedInitiatorType.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedInitiatorType).value = $event)),
            disable: __props.disable,
            dense: "",
            class: "license-select-menu",
            "data-testid": "default-license--initiator-select-menu",
            options: _unref(initiatorsTypesList),
            onInput: handleInitiatorSelection
          }, null, 8, ["value", "disable", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('settings.agents.defaultAgentLicense.helperMenuTitle')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(IncrediSelectMenu, {
            value: selectedHelperType.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedHelperType).value = $event)),
            disable: __props.disable,
            dense: "",
            class: "license-select-menu",
            "data-testid": "default-license--helper-select-menu",
            options: _unref(helpersTypesList),
            onInput: handleHelperSelection
          }, null, 8, ["value", "disable", "options"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})